import './App.css';
import "../src/css/index.css"

import { Routes, Route, Navigate } from 'react-router-dom';
import { routes, RESTRICTED_INTERN_USERID } from './routes/routes';
import { Paths } from './routes/path';
import { useSelector } from "react-redux";

// Components
import Header from './customs/Header';
import LoginPage from './pages/LoginPage';

const AppRoutes = () => {
	const { userData } = useSelector((state) => state.auth);

	const isRestrictedIntern = userData?.userid?.startsWith(RESTRICTED_INTERN_USERID);
	const userRoutes = userData
		? isRestrictedIntern
			? routes.intern
			: routes[userData.role]
		: [];

	if (!userData) {
		return (
			<>
				<Header hideHeader />
				<Routes>
					<Route path="/login" element={<LoginPage />} />
					<Route path="*" element={<Navigate to="/login" />} />
				</Routes>
			</>
		);
	}

	return (
		<>
			<Header />
			<Routes>
				{/* Redirect to home page if user already logged in */}
				<Route path="/login" element={<Navigate to={Paths.Main} replace />} />

				{userRoutes?.map((route) => (
					<Route key={route.path} path={route.path} element={route.element} />
				))}

				{/* Redirect unknown paths to home for logged in users */}
				<Route path="/*" element={<Navigate to={isRestrictedIntern ? Paths.CiriumScreen : Paths.Main} />} />
			</Routes>
		</>
	);
};

export default AppRoutes;
